import { call, put, takeLatest } from 'redux-saga/effects';
import { setError } from '../../reducers/error';
import { get } from 'lodash-es';
import {
	setActionLoaderFalse,
	setActionLoaderTrue,
} from '../../reducers/actionLoader';
import { get_most_bought_scrip } from '../../../apis/mostBoughtScrip';
import {
	fetchMostBoughtStocks,
	setMostBoughtPullRefreshState,
	setMostBoughtStocks,
} from '../../reducers/equity/mostBoughtStock';
import { PULL_REFRESH_STATE } from '../../../constants/common';

export default function* fetchMostBoughtSaga() {
	yield takeLatest(
		fetchMostBoughtStocks.toString(),
		handleFetchMostBoughtStocks,
	);
}

function* handleFetchMostBoughtStocks({ payload }) {
	const { Api, screen, isPullToRefresh = false } = payload;
	if (!isPullToRefresh) {
		yield put(setActionLoaderTrue(fetchMostBoughtStocks));
		yield put(setError({ screen, isFetchFailed: false, message: '' }));
	}
	try {
		const response = yield call(get_most_bought_scrip, Api);
		const data = get(response, 'data', []);
		yield put(setMostBoughtStocks(data));
		if (isPullToRefresh) {
			yield put(
				setMostBoughtPullRefreshState({
					[PULL_REFRESH_STATE.IS_SUCCESS]: true,
				}),
			);
		}
	} catch (error) {
		if (isPullToRefresh) {
			yield put(
				setMostBoughtPullRefreshState({
					[PULL_REFRESH_STATE.IS_FAILED]: true,
				}),
			);
		} else {
			yield put(
				setError({
					screen,
					isFetchFailed: true,
					message: error.message,
				}),
			);
		}
	} finally {
		yield put(setActionLoaderFalse(fetchMostBoughtStocks));
	}
}
